import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { UserTable } from "./components/userTable";
import { ApexChart } from "./components/apexChart";
import styles from "./Analytics.module.css";
import { clearPollResult } from '../../redux/actions/report.action';

export const ShowResult = ({setShowResult, showResult}) => {
  const dispatch = useDispatch();

    const analysisData = useSelector(
      (state) => state?.reporting_dashboardReducer?.poll_analysis
    );
    let info = []
    let count = []
    let listData = [];
    if(Array.isArray(analysisData)){
      listData = analysisData;
    } else{
      info = analysisData?.info
      count = analysisData?.count
    }
    // const {info, count} = analysisData
    console.log("analysisData", analysisData);
    console.log("info", info);
    console.log("count", count);
    console.log("listData", listData);

  const handleReset = () => {
    setShowResult(false);
    dispatch(clearPollResult(true));
  };
    
  return (
    <>
            <div className={styles.dashboardContainer}>
      {/* ✅ CASE 1: info + count */}
      {info.length > 0 && count?.[0]?.total_users > 0 ? (
        <>
          <button className={styles.resetButton} onClick={handleReset}>
            Reset
          </button>
          <div className={styles.overview__wrapper}>
            {/* Chart */}
            <div className={styles.overview}>
              <div className={styles.overview__head}>
                <h2>Registration Count</h2>
              </div>
              <hr />
              <ApexChart data={count[0]} />
            </div>

            {/* Table */}
            <div className={styles.overview}>
              <div className={styles.overview__head}>
                <h2>User Info</h2>
              </div>
              <hr />
              <div className={styles.five__referrals}>
                <UserTable users={info} />
              </div>
            </div>
          </div>
        </>
      ) : listData.length > 0 ? (
        // ✅ CASE 2: only listData
        <>
          <button className={styles.resetButton} onClick={handleReset}>
            Reset
          </button>
          <div className={styles.overview}>
            <div className={styles.overview__head}>
              <h2>User List</h2>
            </div>
            <hr />
            <div className={styles.five__referrals}>
              <UserTable users={listData} />
            </div>
          </div>
        </>
      ) : (
        // ❌ CASE 3: No data
        <div className={styles.noData}>
          <button className={styles.resetButton} onClick={handleReset}>
            Reset
          </button>
          <h2>No data Found 😌</h2>
        </div>
      )}
    </div>
    </>
  )
}
